import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@/context/ThemeContext';
import { AuthProvider } from '@/hooks/useAuth';
import { FacilityProvider } from '@/contexts/FacilityContext';
import { CareFeatureGateProvider } from '@/contexts/CareFeatureGateContext';
import { ToastProvider } from '@/components/shared/Toast';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import MonitoringController from '@/components/MonitoringController';
import { router } from '@/routes/index';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: 3,
            retryDelay: (attempt) => Math.min(1_000 * 2 ** attempt, 15_000),
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            refetchOnMount: false,
        },
        mutations: {
            retry: 0,
        },
    },
});

export default function App() {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <ThemeProvider>
                    <AuthProvider>
                        <MonitoringController />
                        <FacilityProvider>
                            <CareFeatureGateProvider>
                                <ToastProvider>
                                    <RouterProvider router={router} />
                                </ToastProvider>
                            </CareFeatureGateProvider>
                        </FacilityProvider>
                    </AuthProvider>
                </ThemeProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    );
}
